import API from "../../api/chartservice";
import router from "../../router/index";
import axios from "axios";

const state = {
  isFullScreen: false,
  chartDownloadInfo: [],
  historyCalDropDown: [],
  currentVersionaHolder: [],
  userInfo: [],
  currentChartName: ""
};

const getters = {
  isFullScreen: (state) => state.isFullScreen,
  chartDownloadInfo: (state) => state.chartDownloadInfo,
  historyCalDropDown: (state) => state.historyCalDropDown,
  currentVersionaHolder: (state) => state.currentVersionaHolder,
  userInfo: (state) => state.userInfo,
  currentChartName: (state) => state.currentChartName,
};

const actions = {
  async saveChartHistoricalData({ commit, dispatch }, chartinfo) {
    try {
      dispatch("showLoader");
      // if(typeof chartinfo.chartName == 'undefined' || chartinfo.chartName == ''){
      //   return false;
      // }
      // const chartname = chartinfo.chartName;
      // let response = await API.saveChartHistoricalDetail(chartinfo);
      await API.saveChartHistoricalDetail(chartinfo);
      // const responsedata = response.data.message;
      // commit("SET_HISTORYCAL_DROP_DOWN", response.data.drop_down_values);
      dispatch("hideLoader");
      // return responseAllData;
    } catch (error) {
      dispatch("hideLoader");
      console.log(error);
      if(error.response && error.response.status && typeof error.response.status != 'undefined' && error.response.status === 401){
        router.push({ name: "logout" });
      }
      commit("SET_ERROR", error);
    }
  },
  async getChartHistoricalData({ commit, dispatch }, chartinfo) {
    // console.log("history++++", chartinfo);
    // debugger;
    try {
      dispatch("showLoader");
      if(chartinfo.table_pk == undefined || typeof chartinfo.chartName == 'undefined' || chartinfo.chartName == ''){
        return false;
      }
      const chartname = chartinfo.chartName;
      // const id = chartinfo.id;
      // const navigate = !!chartinfo.navigate;
      // const path = chartinfo.path;
      let response = await API.getChartHistoricalDetail(chartinfo);
      // console.log('response-===-',response);
      const responsedata = response.data.message;
      commit("SET_HISTORYCAL_DROP_DOWN", response.data.drop_down_values);
      commit("SET_CURRENT_CHART_NAME", response.data.chart_name);
      const responseAllData = response.data;
      // console.log('chartName-==-=-',chartname, chartinfo);
      const mutationName = chartname
        .toUpperCase()
        .replace("-", "")
        .replace(/-/g, "")
        .replace(/\s/g, "")
        .replace("(", "")
        .replace("$", "")
        .replace(/[-,.:%&/]/g, "")
        .replace(")", "");
      // console.log("committttttttt", "SET_" + mutationName);
      commit("SET_" + mutationName, responsedata);
      // if (navigate) dispatch("moveToComponentByPath", path);
      dispatch("hideLoader");
      return responseAllData;
    } catch (error) {
      dispatch("hideLoader");
      console.log(error);
      if(error.response && error.response.status && typeof error.response.status != 'undefined' && error.response.status === 401){
        router.push({ name: "logout" });
        //this.$router.push('/logout');
      }
      commit("SET_ERROR", error);
    }
  },
  async getChartDataById({ commit, dispatch }, chartinfo) {
    try {
      // console.log("getChartDataById--API++++");
      dispatch("showLoader");
      if(typeof chartinfo.chartName == 'undefined' || chartinfo.chartName == ''){
        return false;
      }
      const chartname = chartinfo.chartName;
      const id = chartinfo.id;
      const navigate = !!chartinfo.navigate;
      const path = chartinfo.path;
      let response = await API.getChartDetail(id);
      // console.log('response-===-',response);
      commit("SET_HISTORYCAL_DROP_DOWN", response.data.drop_down_values);
      commit("SET_USER_INFO", response.data.user_info);
      commit("SET_CURRENT_CHART_NAME", response.data.chart_name);
      const responsedata = response.data.message;
      const responseAllData = response.data;
      // console.log('chartName-==-=-',chartname, chartinfo);
      const mutationName = chartname
        .toUpperCase()
        .replace("-", "")
        .replace(/-/g, "")
        .replace(/\s/g, "")
        .replace("(", "")
        .replace("$", "")
        .replace(/[-,.:%&/]/g, "")
        .replace(")", "");
        // console.log("__________", "SET_" + mutationName);
      commit("SET_" + mutationName, responsedata);
      if (navigate) dispatch("moveToComponentByPath", path);
      dispatch("hideLoader");
      return responseAllData;
    } catch (error) {
      dispatch("hideLoader");
      console.log(error);
      if(error.response && error.response.status && typeof error.response.status != 'undefined' && error.response.status === 401){
        router.push({ name: "logout" });
        //this.$router.push('/logout');
      }
      commit("SET_ERROR", error);
    }
  },
  async getChildrenInfoByParentName({ commit, dispatch }, parent) {
    try {
      let response = await API.getChildrenInfoByParentName(parent);
      const bucketChildren = response.data.message;
      const firstChild = bucketChildren[0];
      //console.log("firstChild", firstChild);
      dispatch("getChartDataById", firstChild);
      commit("SET_" + parent.toUpperCase().replace("-", ""), bucketChildren);
    } catch (error) {
      console.log(error);
      commit("SET_ERROR", error);
    }
  },
  async moveToComponentByPath({ commit }, path) {
    router.push(path);
  },
  setScreenStatus: ({ commit }, fullscreen) => {
    commit("SET_FULLSCREEN_STATUS", fullscreen);
  },
  setDownloadInfo: ({ commit }, downloadInfo) => {
    commit("SET_DOWNLOAD_INFO", downloadInfo);
  },
  async getIframeChartDataById({ commit, dispatch }, id) {
    try {
      dispatch("showLoader");
      if(id== undefined || id == null){
        return false;
      }
      let response = await API.getChartDetail(id);
      commit("SET_HISTORYCAL_DROP_DOWN", response.data.drop_down_values);
      commit("SET_USER_INFO", response.data.user_info);
      commit("SET_CURRENT_CHART_NAME", response.data.chart_name);
      return response.data.message;
    } catch (error) {
      dispatch("hideLoader");
      console.log(error);
      if(error.response && error.response.status && typeof error.response.status != 'undefined' && error.response.status === 401){
        router.push({ name: "logout" });
        //this.$router.push('/logout');
      }
      commit("SET_ERROR", error);
    }
  },
  currentVersionUpdateHandler ({ commit }, currentVersionaHolder) {
    commit("SET_CURRENT_VERSION_HOLDER", currentVersionaHolder);
  },
  userInfoHandler ({ commit }, userInfo) {
    commit("SET_USER_INFO", userInfo);
  },
  // peelhunt sectors dropdwon data api integration
  async getPeelhuntSectorsData({ commit, dispatch }, chartinfo) {
    try {
      // dispatch("showLoader");
      let response = {};
      response = await API.getPeelhuntSectorsNameList();
      const responsedata = response && response.data;
      commit("SET__SECTORS_PEELHUNT", responsedata);
      // dispatch("hideLoader");
      return responsedata;
    } catch (error) {
      // dispatch("hideLoader");
      console.log( error.response);
      if (
        error &&
        error.response &&
        error.response.status &&
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
  async getPeelhuntTableData({ commit, dispatch }, data) {
    try {
      // dispatch("showLoader");
      let response = {};
      response = await API.getPeelhuntTableList(data);
      // console.log("response-===-", response.data);
      const responsedata = response && response.data && response.data;
      // commit("SET_PEELHUNTTABLE", responsedata);
      // dispatch("hideLoader");
      return responsedata;
    } catch (error) {
      // dispatch("hideLoader");
      console.log(error);
      if (
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
        //this.$router.push('/logout');
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
  async customIndexAPIHandler({ commit, dispatch }, data) {
    try {
      // dispatch("showLoader");
      let response = {};
      // const data = data.data
      response = await API.getPeelhuntPricePerformanceData(data, "GetCustomIndex");
      // console.log("response-===-", response);
      const responsedata = response && response.data;
      //console.log('chartName-==-=-',chartname);
      // commit("SET_PEELHUNTTABLE", responsedata);
      // dispatch("hideLoader");
      return responsedata;
    } catch (error) {
      // dispatch("hideLoader");
      console.log(error);
      if (
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
        //this.$router.push('/logout');
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
  async getCustomIndexDropdown({ commit, dispatch }, chartinfo) {
    try {
      // dispatch("showLoader");
      let response = {};
      response = await API.getCustomIndexDropdown();
      const responsedata = response && response.data;
      // commit("SET__SECTORS_PEELHUNT", responsedata);
      // dispatch("hideLoader");
      return responsedata;
    } catch (error) {
      // dispatch("hideLoader");
      console.log(error);
      if (
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
  async getRiskAdjustedTableData({ commit, dispatch }, chartinfo) {
    try {
      // dispatch("showLoader");
      let response = {};
      response = await API.getPeelhuntPricePerformanceData(chartinfo, 'GetRiskAdjustedReturn');
      // console.log("response-===-", response.data.data);
      const responsedata = response && response.data;
      commit("SET__SECTORS_PEELHUNT", responsedata);
      // dispatch("hideLoader");
      return responsedata;
    } catch (error) {
      // dispatch("hideLoader");
      console.log(error);
      if (
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
  async getPricePerformanceToggel({ commit, dispatch }, chartinfo) {
    try {
      // dispatch("showLoader");
      let response = {};
      // console.log("chartinfo++++++>>>>>>", chartinfo);
      response = await API.getPeelhuntPricePerformanceData(chartinfo, 'GetPricePerformance');
      // console.log("response-===-", response.data.data);
      const responsedata = response && response.data;
      commit("SET__SECTORS_PEELHUNT", responsedata);
      // dispatch("hideLoader");
      return responsedata;
    } catch (error) {
      // dispatch("hideLoader");
      console.log(error);
      if (
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
};
const mutations = {
  SET_FULLSCREEN_STATUS: (state, fullscreen) => {
    state.isFullScreen = fullscreen;
  },
  SET_DOWNLOAD_INFO: (state, downloadInfo) => {
    state.chartDownloadInfo = downloadInfo;
  },
  SET_HISTORYCAL_DROP_DOWN: (state, historyCalDropDown) => {
    state.historyCalDropDown = historyCalDropDown;
  },
  SET_CURRENT_VERSION_HOLDER: (state, currentVersionaHolder) => {
    state.currentVersionaHolder = currentVersionaHolder;
  },
  SET_USER_INFO: (state, userInfo) => {
    // console.log("stateeeeeeee++========++", userInfo);
    state.userInfo = userInfo;
  },
  SET_CURRENT_CHART_NAME: (state, currentChartName) => {
    // console.log("stateeeeeeee++========++", currentChartName);
    state.currentChartName = currentChartName;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
